import React from 'react';
import { useTranslation } from 'react-i18next';
import { Feedback } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function FeedbackPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('feedback-component.metatags.title'),
        description: t('feedback-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.orderFeedback,
        index: false,
    });

    return <Feedback />;
}
